import { WorkflowAnalysis } from "../types/types"
import { genericRequest, workflowAnalysisRoute } from "./service"

/**
 * Creates a new workflow analysis in star cloud database.
 * 
 * @param workflowId to associate analysis with
 * @param comment to add
 * @param cui wheather CUI is present
 * @param mui wheather MUI is present
 * 
 * @returns created workflow anlaysis object
 */
export const addWorkflowAnalysis = (workflowId: number, comment: string, cui: boolean, mui: boolean): Promise<WorkflowAnalysis | Error> => {
  const body = JSON.stringify({
    corrosion_suspected: cui,
    moisture_suspected: mui,
    comment: comment
  })
  return genericRequest({ url: `${workflowAnalysisRoute}/${workflowId}`, method: "POST", body: body })
}

/**
 * Gets workflow analysis for a given workflow.
 * 
 * @param workflowId of anlysis to fetch
 * 
 * @returns analysis for a given workflow.
 */
export const getWorkflowAnalysis = (workflowId: number): Promise<WorkflowAnalysis[] | Error> => {
  return genericRequest({ url: `${workflowAnalysisRoute}/workflow/${workflowId}`, method: "GET" })
}

/**
 * Updates workflow analysis.
 * 
 * @param analysisId to update
 * @param comment to ad
 * @param cui suspected cui
 * @param mui suspected mui
 * 
 * @returns update analysis object
 */
export const updateWorkflowAnalysis = (analysisId: number, comment: string, cui: boolean, mui: boolean): Promise<WorkflowAnalysis | Error> => {
  const body = JSON.stringify({
    corrosion_suspected: cui,
    moisture_suspected: mui,
    comment: comment
  })
  return genericRequest({ url: `${workflowAnalysisRoute}/${analysisId}`, method: "PUT", body: body })
}